import { tabToPath } from "../store/appStore";

// Environment detection for playground (only shown in dev)
const isDev = import.meta.env.MODE === "development";

/**
 * Get consistent sidebar sections configuration for all pages
 * @param activeTab Current active tab
 * @param setActiveTab Function to set active tab
 * @returns Sidebar sections configuration
 */
export const getSidebarSections = (
  activeTab: string,
  setActiveTab: (tab: string) => void
) => {
  // We only need to set the active tab,
  // the navigation itself will be handled by the SidebarItem component
  const createClickHandler = (tabName: string) => () => {
    setActiveTab(tabName);
  };

  const sections = [
    {
      items: [
        {
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
          ),
          label: "Overview",
          onClick: createClickHandler("overview"),
          isActive: activeTab === "overview",
          to: tabToPath.overview,
        },
        {
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
              />
            </svg>
          ),
          label: "Synthetic Workers",
          onClick: createClickHandler("synthetic-workers"),
          isActive: activeTab === "synthetic-workers",
          to: tabToPath["synthetic-workers"],
        },
        {
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          ),
          label: "Work Log",
          onClick: createClickHandler("work-log"),
          isActive: activeTab === "work-log",
          to: tabToPath["work-log"],
        },
        {
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          ),
          label: "Connections",
          onClick: createClickHandler("connections"),
          isActive: activeTab === "connections",
          to: tabToPath.connections,
        },
      ],
    },
  ];

  // Only add the Playground section in development mode
  if (isDev) {
    sections.push({
      items: [
        {
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
              />
            </svg>
          ),
          label: "Playground",
          onClick: createClickHandler("playground"),
          isActive: activeTab === "playground",
          to: tabToPath.playground,
        },
      ],
    });
  }

  return sections;
};
